import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";

export interface ContractsStats {
  vigentes: number;
  por_vencer: number;
  finalizados: number;
}

export const fetchContractsStats = async (): Promise<ApiResponse<ContractsStats>> => {
  return apiClient<ApiResponse<ContractsStats>>('/v1/contratos/estadisticas', {
    method: "GET"
  });
};
